// extracted by mini-css-extract-plugin
module.exports = {"base":"Notification_base__oojBx","notifications-wrapper":"Notification_notifications-wrapper__IsGOf"};